import Client from "./Kumovega/Client";
import SearchClient from "./Kumovega/SearchClient";
import * as Errors from "./Kumovega/Errors";

export { Client, SearchClient, Errors };
export default { Client, SearchClient, Errors };
